import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { SITE } from "@/constants/site";

const socials = [
  [Instagram, SITE.instagram],
  [Facebook, "#"],
  [Youtube, "#"],
];

export function Footer() {
  return (
    <footer className="bg-warmblack border-t border-[#C9A45C]/15 mt-16" data-testid="main-footer">
      <div className="max-w-[1500px] mx-auto px-5 lg:px-10 py-14 grid grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Link to="/"><img src="/errah-logo.png" alt="ERRAH — Protect What Matters" className="h-20 w-auto object-contain -ml-1" /></Link>
          <p className="mt-3 text-gray-500 text-sm max-w-xs leading-relaxed">
            Premium Surface Protection Films & Nano Coatings for modern homes, furniture, interiors and commercial spaces.
          </p>
          <div className="flex gap-3 mt-5">
            {socials.map(([I, href], i) => (
              <a key={i} href={href} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${i}`}
                className="w-9 h-9 border border-[#C9A45C]/25 flex items-center justify-center text-gray-400 hover:bg-[#C9A45C] hover:text-black transition-colors"><I size={16} /></a>
            ))}
          </div>
        </div>
        <FooterCol title="Solutions" items={[["Surface Protection Film", "/solutions/surface-protection-film"], ["Nano Coating", "/solutions/nano-coating"], ["Marble & Stone", "/marble-protection"], ["Kitchen Countertops", "/kitchen-protection"]]} />
        <FooterCol title="Applications" items={[["Dining Tables", "/tabletop-protection"], ["Sofas & Upholstery", "/products"], ["Curtains", "/products"], ["Glass Surfaces", "/glass-protection"]]} />
        <FooterCol title="Company" items={[["About", "/about"], ["Projects", "/projects"], ["Become a Partner", "/partners"], ["Applicator Network", "/applicator-network"], ["Contact", "/contact"], ["Partner Login", "/partner/login"]]} />
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-gray-600">
        © {new Date().getFullYear()} ERRAH — {SITE.domain}. Protect what matters.
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <p className="errah-label mb-4">{title}</p>
      <ul className="space-y-2.5">
        {items.map(([label, to]) => (
          <li key={label}><Link to={to} className="text-sm text-gray-400 hover:text-[#C9A45C] transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
